<div class="label-container" *ngIf="label">
    <label [for]="name">{{ getLabel() }}</label>
</div>

<div class="border"
     [class.disabled]="isDisabled"
     [class.open]="isOpen && !isDisabled"
     (click)="toggleDropdown(optionsContainer)"
     (focus)="onFocus()"
     (blur)="onBlur()"
     tabindex="0">

    <div class="selected-value input" [ngClass]="{'placeholder': !getSelectedLabel() }">
        {{ getSelectedLabel() || placeholder }}
    </div>

    <div class="options-container" #optionsContainer>
        <div class="options" *ngIf="isOpen" @fadeSlide>
            <div *ngFor="let option of options; let i = index"
                 class="option"
                 [class.highlighted]="isHighlighted(i)"
                 [class.disabled]="option.isDisabled"
                 [class.selected]="option.value === value"
                 (click)="selectOption(option)">
                {{ option.label }}
            </div>
        </div>
    </div>

    <i class="fa fa-chevron-down arrow"></i>
</div>

